import Vue from 'vue'
import Vuex from 'vuex'
import me from './me'
import auth from './auth'
import job from './job'
import error from './error'
import report from './report'
import masterData from './masterData'
import success from './success'
import stock from './stock'
import aiImageDetection from './aiImageDetection'

import createLogger from './logger'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.VUE_APP_ENV === 'local'
const plugins = []

if (debug) {
  plugins.push(createLogger())
  //   plugins.push(createPersistedState())
}

export default new Vuex.Store({
  modules: {
    // stepStore,
    me,
    auth,
    job,
    masterData,
    error,
    report,
    success,
    stock,
	aiImageDetection
  },
  strict: debug,
  plugins: plugins,
})
